export enum ENUM__generation_setting_change {
  /*
   * DIFFUSION SETTIGNS
   */
  GUIDANCE_SCALE_USE = 'GUIDANCE_SCALE_USE',
  GUIDANCE_SCALE_SLIDER_STEP = 'GUIDANCE_SCALE_SLIDER_STEP',

  GUIDANCE_RESCALE_USE = 'GUIDANCE_RESCALE_USE',
  GUIDANCE_RESCALE_SLIDER_STEP = 'GUIDANCE_RESCALE_SLIDER_STEP',

  INFERENCE_STEPS_USE = 'INFERENCE_STEPS_USE',
  INFERENCE_STEPS_SLIDER_STEP = 'INFERENCE_STEPS_SLIDER_STEP',

  SCHEDULER_TYPE_USE = 'SCHEDULER_TYPE_USE',
  SCHEDULER_TYPE_VISIBILITY = 'SCHEDULER_TYPE_VISIBILITY',

  SEED_VISIBILITY = 'SEED_VISIBILITY',
  SEED_USE = 'SEED_USE',
  SEED_ADD = 'SEED_ADD',
  SEED_DELETE = 'SEED_DELETE',

  /*
   * LORA
   */
  LORA_SCALE_USE = 'LORA_SCALE_USE',
  LORA_SCALE_SLIDER_STEP = 'LORA_SCALE_SLIDER_STEP',

  /*
   * ML ASSETS
   */

  ML_ASSET_BUNDLE_USE = 'ML_ASSET_BUNDLE_USE',
  ML_ASSET_BUNDLE_VISIBILITY = 'ML_ASSET_BUNDLE_VISIBILITY',

  ML_ASSET_UNET_USE = 'ML_ASSET_UNET_USE',
  ML_ASSET_UNET_VISIBILITY = 'ML_ASSET_UNET_VISIBILITY',

  ML_ASSET_TEXT_ENCODER_USE = 'ML_ASSET_TEXT_ENCODER_USE', //todo: implement
  ML_ASSET_TEXT_ENCODER_VISIBILITY = 'ML_ASSET_TEXT_VISIBILITY', //todo: implement

  ML_ASSET_VAE_USE = 'ML_ASSET_VAE_USE', //todo: implement
  ML_ASSET_VAE_VISIBILITY = 'ML_ASSET_VAE_VISIBILITY', //todo: implement

  ML_ASSET_IMAGE_PROCESSOR_USE = 'ML_ASSET_IMAGE_PROCESSOR_USE',
  ML_ASSET_IMAGE_PROCESSOR_VISIBILITY = 'ML_ASSET_IMAGE_PROCESSOR_VISIBILITY',

  ML_ASSET_IMAGE_ENCODER_USE = 'ML_ASSET_IMAGE_ENCODER_USE',
  ML_ASSET_IMAGE_ENCODER_VISIBILITY = 'ML_ASSET_IMAGE_ENCODER_VISIBILITY',

  /*
   * IMAGE
   */

  IMAGE_CANVAS_ID = 'IMAGE_CANVAS_ID',
  IMAGE_CANVAS_STATUS = 'IMAGE_CANVAS_STATUS',
  IMAGE_CANVAS_STRENGTH_USE = 'IMAGE_CANVAS_STRENGTH_USE',
  IMAGE_CANVAS_STRENGTH_SLIDER_STEP = 'IMAGE_CANVAS_STRENGTH_SLIDER_STEP',
  IMAGE_CANVAS_CROP_BOX = 'IMAGE_CANVAS_CROP_BOX',

  IMAGE_MASK_STATUS = 'IMAGE_MASK_STATUS',
  IMAGE_LINE_GUIDANCE_STATUS = 'IMAGE_LINE_GUIDANCE_STATUS',

  IMAGE_SIZE_USE_ASPECT_RATIO = 'IMAGE_SIZE_USE_ASPECT_RATIO',
  IMAGE_SIZE_USE_MULTIPLIER = 'IMAGE_SIZE_USE_MULTIPLIER',
  /*
   * IMAGE CONTROL NET
   */

  CONTROL_NET_SLIDER_STEP = 'CONTROL_NET_SLIDER_STEP',

  /*
   * IMAGE LINE GUIDANCE
   */

  IMAGE_LINE_GUIDANCE_CONTROL_NET_STEPS_END_USE = 'IMAGE_LINE_GUIDANCE_CONTROL_NET_STEPS_END_USE',
  IMAGE_LINE_GUIDANCE_CONTROL_NET_STEPS_BEGIN_USE = 'IMAGE_LINE_GUIDANCE_CONTROL_NET_STEPS_BEGIN_USE',

  IMAGE_LINE_GUIDANCE_CONTROL_NET_HASH_SHA256_USE = 'IMAGE_LINE_GUIDANCE_CONTROL_NET_HASH_SHA256_USE',
  IMAGE_LINE_GUIDANCE_CONTROL_NET_VISIBILITY = 'IMAGE_LINE_GUIDANCE_CONTROL_NET_VISIBILITY',

  IMAGE_LINE_GUIDANCE_IMAGE_WEIGHT_USE = 'IMAGE_LINE_GUIDANCE_IMAGE_WEIGHT_USE',

  /*
   * IP ADAPTER
   */

  IP_ADAPTER_STATUS = 'IP_ADAPTER_STATUS',

  IP_ADAPTER_SLIDER_STEP = 'IP_ADAPTER_SLIDER_STEP',

  IP_ADAPTER_SCALE_DOWN = 'IP_ADAPTER_SCALE_DOWN',
  IP_ADAPTER_SCALE_MIDDLE = 'IP_ADAPTER_SCALE_MIDDLE',
  IP_ADAPTER_SCALE_UP = 'IP_ADAPTER_SCALE_UP',

  IP_ADAPTER_IMAGES_IDS = 'IP_ADAPTER_IMAGES_IDS',
  IP_ADAPTER_IMAGE_WEIGHT = 'IP_ADAPTER_IMAGE_WEIGHT',
  IP_ADAPTER_IMAGE_VISIBILITY = 'IP_ADAPTER_IMAGE_VISIBILITY',

  /*
   * LORA
   */
  LORA_WEIGHT_MASTER_USE = 'LORA_WEIGHT_MASTER_USE',

  /*
   * TEXT
   */
  TOKEN_VISIBILITY = 'TOKEN_VISIBILITY',
  TOKEN_SIGN = 'TOKEN_SIGN',
  TOKEN_WEIGHT = 'TOKEN_WEIGHT',

  CLIP_SKIP_USE = 'CLIP_SKIP_USE',
}
